// 运营数据表格列共享片段
// 提供「总体数据」「子产品」两个列组的渲染逻辑 + 升降徽标，供三个平台子组件复用。

// 数字格式化
export function fmtNum (val) {
  return val !== null && val !== undefined ? val : '-'
}
// 金额（两位小数）
export function fmtMoney (val) {
  return val !== null && val !== undefined ? Number(val).toFixed(2) : '-'
}
// 转化率（0~1 → 百分比）
export function fmtRate (val) {
  if (val === null || val === undefined) return '-'
  return (Number(val) * 100).toFixed(2) + '%'
}

// 升降徽标 HTML（仅单量、营收用）
// rate: 0~1 小数或 null；返回带样式的 span 字符串
export function deltaBadge (rate) {
  if (rate === null || rate === undefined) return ''
  const pct = (Math.abs(rate) * 100).toFixed(1)
  if (rate > 0) {
    return ` <span style="color:#67c23a;font-size:12px;">↑${pct}%</span>`
  } else if (rate < 0) {
    return ` <span style="color:#f56c6c;font-size:12px;">↓${pct}%</span>`
  }
  return ''
}

// 单量单元格：值 + 升降徽标（用 v-html 渲染）
// prefix: 'total' | 'sub'
export function renderDingdan (prefix) {
  return (h, { row }) => {
    const g = row[prefix] || {}
    const val = fmtNum(g.dingdan)
    return h('span', { domProps: { innerHTML: val + deltaBadge(g.dingdanRate) } })
  }
}

// 营收单元格：值 + 升降徽标
export function renderShouru (prefix) {
  return (h, { row }) => {
    const g = row[prefix] || {}
    const val = fmtMoney(g.shouru)
    return h('span', { domProps: { innerHTML: val + deltaBadge(g.shouruRate) } })
  }
}

// 通用数字单元格
export function renderField (prefix, field, formatter = fmtNum) {
  return (h, { row }) => {
    const g = row[prefix] || {}
    return h('span', formatter(g[field]))
  }
}

// 生成「总体数据」列组配置（el-table-column 的 props 数组）
// 返回数组，每项 { label, width, render }
export function totalColumns () {
  return [
    { label: '单量', width: 100, render: renderDingdan('total') },
    { label: '营收', width: 110, render: renderShouru('total') },
    { label: '曝光人数', width: 90, render: renderField('total', 'baoguang') },
    { label: '入店人数', width: 90, render: renderField('total', 'rudian') },
    { label: '下单人数', width: 90, render: renderField('total', 'xiadan') },
    { label: '下单新客', width: 90, render: renderField('total', 'xinke') },
    { label: '下单老客', width: 90, render: renderField('total', 'laoke') },
    { label: '客单价', width: 85, render: renderField('total', 'kedan', fmtMoney) },
    { label: '实付', width: 85, render: renderField('total', 'shifu', fmtMoney) },
    { label: '入店转化率', width: 100, render: renderField('total', 'rudianRate', fmtRate) },
    { label: '下单转化率', width: 100, render: renderField('total', 'xiadanRate', fmtRate) }
  ]
}

// 生成「子产品」列组配置（美团=拼好饭，淘宝=爆品团，京东不调用）
export function subColumns () {
  return [
    { label: '单量', width: 100, render: renderDingdan('sub') },
    { label: '营收', width: 110, render: renderShouru('sub') },
    { label: '曝光人数', width: 90, render: renderField('sub', 'baoguang') },
    { label: '入店人数', width: 90, render: renderField('sub', 'rudian') },
    { label: '下单人数', width: 90, render: renderField('sub', 'xiadan') },
    { label: '下单新客', width: 90, render: renderField('sub', 'xinke') },
    { label: '下单老客', width: 90, render: renderField('sub', 'laoke') },
    { label: '客单价', width: 85, render: renderField('sub', 'kedan', fmtMoney) },
    { label: '实付', width: 85, render: renderField('sub', 'shifu', fmtMoney) },
    { label: '入店转化率', width: 100, render: renderField('sub', 'rudianRate', fmtRate) },
    { label: '下单转化率', width: 100, render: renderField('sub', 'xiadanRate', fmtRate) }
  ]
}
